import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* markastoplearning<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { literal, learning_status, ...data } = action.payload as {
            literal: string
            learning_status: string
            [key: string]: any
        }

        const resp = yield call(CallApi.POST, APIS.CONTROL_CENTER.MARK_AS_TOP_LEARNING(literal, learning_status), data, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({
            message: e.message,
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'markastoplearning', action: action?.type })
    }
}

export function* restoreexperiment<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { literal, ...data } = action.payload as { literal: string; [key: string]: any }
        const resp = yield call(CallApi.POST, APIS.CONTROL_CENTER.RESTORE_EXPERIMENT(action.payload as any), data, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({
            message: e.message,
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'restoreexperiment', action: action?.type })
    }
}

export function* deleteexperiment<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.DELETE, APIS.CONTROL_CENTER.DELETE_EXPERIMENT(action.payload as any), {}, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({
            message: e.message,
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'deleteexperiment', action: action?.type })
    }
}
export function* markAsExecutiveDashboardExperiment<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { experiment_literal, mark_as_executive_dashboard_experiment, ...data } = action.payload as {
            experiment_literal: string
            mark_as_executive_dashboard_experiment: boolean
            [key: string]: any
        }

        const resp = yield call(CallApi.POST, APIS.CONTROL_CENTER.MARK_AS_EXECUTIVE_DASHBOARD_EXPERIMENT(experiment_literal, mark_as_executive_dashboard_experiment), data, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({
            message: e.message,
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'markAsExecutiveDashboardExperiment', action: action?.type })
    }
}

export function* getallexperiments<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const allowedKeys = new Set(['deleted_only', 'page', 'sort_by', 'per_page'])

        const params: any = Object.fromEntries(Object.entries(action.payload as any).filter(([key]) => allowedKeys.has(key)))

        const resp = yield call(CallApi.POST, APIS.CONTROL_CENTER.GET_ALL_EXPERIMENTS + '?' + new URLSearchParams(params).toString(), action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({
            message: e.message,
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getallexperiments', action: action?.type })
    }
}
